/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2021 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2021-12-03
 *
 * ---------------------------------------------------------------------------
 */

import AlertDialog from './AlertDialog.jsx';

export default AlertDialog;
